import { useCallback } from "react";
import { useDraw } from "react-scribble";
import { normalize } from "../math";
import { AnimatedValue } from "../animated-value";

export const Circle = ({
  x = normalize(Math.random(), 0, 1, 0, window.innerWidth),
  y = normalize(Math.random(), 0, 1, 0, window.innerWidth),
  radius = normalize(Math.random(), 0, 1, 10, 30),
  scroll = new AnimatedValue(0),
  color
}) => {
  const drawCircle = useCallback(
    (ctx, canvas) => {
      ctx.fillStyle =
        color || `rgba(255,255,255,${normalize(radius, 10, 30, 0.5, 1)})`;
      ctx.beginPath();
      ctx.arc(
        x,
        y - scroll.getAnimatedValue() * radius * 0.01,
        radius,
        0,
        Math.PI * 2,
        true
      );
      ctx.fill();
    },
    [color, radius, scroll, x, y]
  );
  useDraw(drawCircle); // draws the circle
  return null; // you can return dom element here too.
};
